import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { trackError } from "@/utils/error-tracking";
import { App } from "./App";
import "./index.css";

// 전역 에러 핸들러: 캐치되지 않은 에러를 Analytics에 기록
window.addEventListener("error", (event) => {
  trackError(event.error ?? event.message, { source: "window.onerror" });
});

// 전역 에러 핸들러: 처리되지 않은 Promise rejection을 Analytics에 기록
window.addEventListener("unhandledrejection", (event) => {
  trackError(event.reason, { source: "unhandledrejection" });
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
